import gql from 'graphql-tag';

const createHistoryEntriesQuery = gql`
  mutation createHistoryEntries($input: [CreateHistoryEntryInput!]!) {
    createHistoryEntries(input: $input) {
      eventId
    }
  }
`;

const createHistoryEntries = () => ({
  mutation: createHistoryEntriesQuery,
  module: 'history',
  buildVariables: (input) => ({
    input
  })
});

export default createHistoryEntries;
